// extracted by mini-css-extract-plugin
module.exports = {"successModalWrapper":"styles_successModalWrapper__MJTfr","congratText":"styles_congratText__dAEO0","successText":"styles_successText__7vym7"};
module.exports.__checksum = "1dd6f26fd397"
